export default __webpack_public_path__ + "static/media/instagram.935f04dc.svg";